import React from "react";
import { Modal, Form, FloatingLabel } from "react-bootstrap";

const EducationModal = ({ show, onHide, submitClick, input, handleInput }) => {
  return (
    <Modal className="centerModal" size="md" show={show} onHide={onHide} centered>
      <Modal.Header className="position-relative border-0 p-4 mb-1">
        <Modal.Title className="fs-3 text-black fw-semibold">Fill The Details</Modal.Title>
        {/* <span
          className="userProfile_educationModal_ok modalClose rounded-circle cursorPointer text-white position-absolute top-50 translate-middle-y d-flex justify-content-center align-items-center"
          onClick={submitClick}
        >
          ok
        </span> */}
      </Modal.Header>
      <Modal.Body className="bg-white py-20 px-4 overflow-y-auto">
        <div className="profilePageModalCheck">
          <Form>
            <FloatingLabel className="mb-4" controlId="floatingInput" label="Enter Degree *">
              <Form.Control
                className="fs-4 userProfile_educationModal_enterDegree"
                type="text"
                placeholder="Enter Degree"
                value={input.education_degree}
                name="education_degree"
                onChange={(e) => handleInput(e)}
              />
            </FloatingLabel>

            <FloatingLabel className="mb-4" controlId="floatingInput" label="Enter College *">
              <Form.Control
                className="fs-4 userProfile_educationModal_enterCollege"
                type="text"
                placeholder="Enter College"
                value={input.education_school}
                name="education_school"
                onChange={(e) => handleInput(e)}
              />
            </FloatingLabel>
            <FloatingLabel className="mb-4" controlId="floatingInput" label="Enter Start Year *">
              <Form.Control
                className="fs-4 userProfile_educationModal_enterStartYear"
                type="number"
                placeholder="Enter Start Year"
                value={input.education_from_year}
                name="education_from_year"
                onChange={(e) => handleInput(e)}
              />
            </FloatingLabel>
            <FloatingLabel className="mb-4" controlId="floatingInput" label="Enter End Year *">
              <Form.Control
                className="fs-4 userProfile_educationModal_enterEndYear"
                type="number"
                placeholder="Enter End Year"
                value={input.education_to_year}
                name="education_to_year"
                onChange={(e) => handleInput(e)}
              />
            </FloatingLabel>
            <FloatingLabel className="mb-4" controlId="floatingTextarea2" label="Description">
              <Form.Control
                className="fs-4 userProfile_educationModal_enterDescriptions p-4"
                as="textarea"
                placeholder="Enter Description"
                rows={3}
                value={input.education_description}
                name="education_description"
                onChange={(e) => handleInput(e)}
              />
            </FloatingLabel>
            <div className="d-flex flex-wrap centerModalBttns">
              <button
                className="col fs-4 btn btn-danger py-3 px-4 userProfile_emailModal_cancel"
                type="button"
                aria-label="Cancel"
                onClick={onHide}
              >
                Cancel
              </button>
              <button
                className="col fs-4 btn btn-primary py-3 px-4 userProfile_emailModal_submit"
                type="button"
                onClick={submitClick}
                aria-label="Submit"
              >
                Submit
              </button>
            </div>
          </Form>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EducationModal;
